<template>
  <CourseList
    level-key="elementaryLevel"
    fetch-action="getCourseElementaries"
    getter-name="courseElementaries"
  />
</template>

<script>
import CourseList from "@/components/CourseList.vue";

export default {
  name: "ElementaryCourse",
  components: { CourseList },
};
</script>
